import { useEffect } from "react";
import { useLocation } from "wouter";

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  article?: boolean;
}

export default function SEO({
  title = "Stanford Logistics Management - Acquiring Excellence in Trucking & Logistics",
  description = "Stanford Logistics Management acquires high-quality trucking and logistics companies, providing strategic oversight that enhances operations, strengthens leadership teams, and unlocks long-term value.",
  keywords = "trucking acquisition, logistics M&A, transportation investment, private equity trucking, logistics management, supply chain investment",
  ogImage = "/og-image.png",
  article = false
}: SEOProps) {
  const [location] = useLocation();

  useEffect(() => {
    // Update document title
    document.title = title;

    // Update or create meta tags
    const updateMetaTag = (name: string, content: string, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    };

    // Standard meta tags
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);

    // Open Graph tags
    updateMetaTag('og:title', title, true);
    updateMetaTag('og:description', description, true);
    updateMetaTag('og:type', article ? 'article' : 'website', true);
    updateMetaTag('og:url', window.location.href, true);
    updateMetaTag('og:image', window.location.origin + ogImage, true);

    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:image', window.location.origin + ogImage);

    // Additional SEO tags
    updateMetaTag('robots', 'index, follow');
    updateMetaTag('author', 'Stanford Logistics Management');
  }, [title, description, keywords, ogImage, article, location]);

  return null;
}
